import { REACT_APP_AUTH_URL } from "../../../../../constants/env";
import type { IApiClientService } from "../../../../services/ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../../../../services/AxiosApiClientInstance/AxiosApiClientInstance";
import type { ExternalLoginTokenExchangeDTO } from "../dto/token-exchange.dto";
import type { IExternalLoginDatasource } from "./external-login.datasource.interface";

export class ExternalLoginDatasource implements IExternalLoginDatasource {
  private readonly _EXCHANGE_TOKEN_URL = "/auth/api/v2/sso/exchange-token";
  private readonly _UPGRADE_FIRST_ELIGIBILITY_URL = "/auth/api/v1/authentication/upgrade-first-eligibility";

  constructor(
    private readonly _client: IApiClientService = new AxiosApiClientInstance({
      baseURL: REACT_APP_AUTH_URL as string,
    }),
    private readonly _authenticatedClient: IApiClientService = new AxiosApiClientInstance({
      baseURL: REACT_APP_AUTH_URL as string,
      withCredentials: true,
    })
  ) {}

  public async exchangeNonceToken(authenticationToken: string): Promise<ExternalLoginTokenExchangeDTO> {
    const payload = { authenticationToken };

    const { data } = await this._client.post<{ authenticationToken: string }, ExternalLoginTokenExchangeDTO>(
      this._EXCHANGE_TOKEN_URL,
      payload
    );

    if (!data) {
      throw new Error("Failed to exchange nonce authenticationToken: no response data.");
    }

    return data;
  }

  public async triggerUpgradeFirstEligibility(nextUrl?: string): Promise<void> {
    const url = nextUrl
      ? `${this._UPGRADE_FIRST_ELIGIBILITY_URL}?nextURL=${encodeURIComponent(nextUrl)}`
      : this._UPGRADE_FIRST_ELIGIBILITY_URL;
    await this._authenticatedClient.get(url, {});
  }
}
